<template>
  <div>
    <custom-dialog
      :title="model.title"
      width="1550px"
      :visible="visible"
      :append-to-body="true"
      v-on="$listeners"
      class="refund-register-dialog"
    >
      <div class="dialog-body">
        <div class="info-container">
          <div class="l">
            <!-- 合同订单信息 -->
            <bill-container
              :title="$t('fms_refund_register_dialog.ytzdxx')"
              style="padding-bottom: 16px;"
            >
              <div slot="header">
                <el-button
                  v-if="model.type !== 'watch'"
                  type="primary"
                  size="mini"
                  @click="onAddRefund"
                >{{ $t('fms_refund_register_dialog.tjytk') }}</el-button>
                <!-- 如果实退/实收为正数，则不显示该字段，以免难以理解（产品） -->
                <div
                  class="money"
                  v-if="actualRefundSum <= 0"
                >
                  <div class="key">{{type === 'pay' ? $t('fms_refund_register_dialog.sjytjehj') : $t('fms_refund_register_dialog.sjystkhj')}}：</div>
                  <div class="val">￥{{ actualRefundSum }}</div>
                </div>
                <div class="money">
                  <div class="key">{{type === 'pay' ? $t('fms_refund_register_dialog.ying_tui_jin_e_he_ji') : $t('fms_refund_register_dialog.ystkhj')}}：</div>
                  <div class="val">￥{{ shouldRefundSum }}</div>
                </div>
              </div>
              <custom-table
                index
                :data="orderViewList"
                :tableCode="type === 'receive' ? 'refund_info_refund_bill' : 'refund_record_order'"
                :filterArr="model.type === 'watch' ? ['action'] : []"
                :slots="['totalTerm', 'termUseTime', 'action', 'payableOrgName', 'receivableOrgName']"
              >
                <template v-slot:payableOrgName="scope">
                  {{isReverse ? scope.row.receivableOrgName : scope.row.payableOrgName}}
                </template>
                <template v-slot:receivableOrgName="scope">
                  {{isReverse ? scope.row.payableOrgName : scope.row.receivableOrgName}}
                </template>
                <template
                  slot="totalTerm"
                  slot-scope="scope"
                >
                  <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
                </template>
                <template
                  slot="termUseTime"
                  slot-scope="scope"
                >
                  <div>{{ scope.row.termUseTime }}{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</div>
                </template>
                <template
                  slot="action"
                  slot-scope="scope"
                >
                  <el-button
                    type="text"
                    size="mini"
                    @click="onDelRefund(scope.row)"
                    :disabled="orderViewList.length === 1"
                  >{{ $t('Common.com_delete') }}</el-button>
                </template>
              </custom-table>
            </bill-container>
            <!-- 申请退款方式 -->
            <div style="padding: 16px 6px">
              <el-form
                :model="form"
                ref="form"
              >
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item
                      :label="$t('fms_refund_register_dialog.xztkfs')"
                      prop="refundMethod"
                      class="is-required"
                    >
                      <custom-select
                        v-model="form.refundMethod"
                        :disabled="!!tradeBoList.length || model.type === 'watch'"
                        code="refund_method"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <!-- 付款信息 -->
            <bill-container
              :title="$t('fms_refund_register_dialog.tui_kuan_xin_xi')"
              v-if="form.refundMethod && form.refundMethod != 22"
            >
              <accounts-registration-msg-bill
                ref="msgBill"
                :auth="model.type === 'watch' ? [] : null"
                tableCode="fms_refund_msg_bill"
                v-model="tradeBoList"
                :orderNum="getPaymentCode(registerMsg)"
                :payableTotal="Math.max(payableTotal * -1, 0)"
                :billInfo="registerMsg"
                :outerItem="firstOrderItem"
                :expandFlowMsg="true"
                :paymentClass="form.refundMethod"
                :sellerTradeType="0"
                :isRefund="true"
                :isReverse="true"
              ></accounts-registration-msg-bill>
            </bill-container>
          </div>
          <div class="r">
            <div class="pay-info">
              <div class="title">{{ $t('fms_refund_register_dialog.zhi_fu_xiang_qing') }}</div>
              <div class="order-code">
                <div class="label">{{ $t('fms_refund_register_dialog.ding_dan_bian_hao') }}:</div>
                <div class="value">{{getPaymentCode(registerMsg)}}</div>
              </div>
              <div class="order-code">
                <div class="label">{{ $t('fms_refund_register_dialog.shou_kuan_fang') }}:</div>
                <div class="value">{{isReverse ? firstOrderItem.payableOrgName : firstOrderItem.receivableOrgName}}</div>
              </div>
              <div class="group-list">
                <div class="group">
                  <div class="amount">
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.ying_tui_jin_e') }}：</span>￥{{Math.abs(shouldRefundSum)}}</div>
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.ying_shou_jin_e') }}：</span>￥{{shouldReceiveSum}}</div>
                    <div class="details">
                      <div class="item">
                        <div class="key">{{ $t('fms_refund_register_dialog.zu_lin_yu_e') }}</div>
                        <div class="val">￥{{expectUseRest}}</div>
                      </div>
                      <div class="item">
                        <div class="key">{{ $t('fms_refund_register_dialog.dui_gong_zhuan_zhang') }}</div>
                        <div class="val">￥{{publicAmount}}</div>
                      </div>
                      <div class="item">
                        <div class="key">{{ $t('fms_refund_register_dialog.xian_jin_zhi_fu') }}</div>
                        <div class="val">￥{{cashAmount}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="group"
                  v-if="refundMethodIsUseBalance"
                >
                  <div
                    class="amount"
                    v-if="!isReceivable || balanceType === 2"
                  >
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.dqzlye') }}：</span><span>￥{{ finalRest - expectUseRest }}</span></div>
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.shi_tui_zu_lin_yu_e') }}：</span><span>￥{{ expectUseRest }}</span></div>
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.tkhzlye') }}：</span><span>￥{{ finalRest }}</span></div>
                  </div>
                  <div
                    class="amount"
                    v-else
                  >
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.dqzlye') }}：</span><span>￥{{ finalRest }}</span></div>
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.shi_tui_zu_lin_yu_e') }}：</span><span>￥{{ expectUseRest }}</span></div>
                    <div class="should-pay"><span class="bold">{{ $t('fms_refund_register_dialog.tkhzlye') }}：</span><span>￥{{ finalRest - expectUseRest }}</span></div>
                  </div>
                </div>
                <div
                  class="group"
                  v-else
                >
                  <div class="amount">
                    <!-- 如果 实收/实退 大于0，则label设置为实收(产品) -->
                    <div class="should-pay"><span class="bold">{{ actualRefundSum > 0 ? $t('fms_refund_register_dialog.shi_shou_jin_e') : $t('fms_refund_register_dialog.shi_tui_jin_e') }}：</span><span>￥{{ expectUseRest + publicAmount + cashAmount }}</span></div>
                  </div>
                </div>
                <div class="group">
                  <div
                    class="amount"
                    v-if="receiveConfirmTime"
                  >
                    <div class="should-pay">
                      <span class="bold">{{$t('fms_refund_register_dialog.cao_zuo_shi_jian')}}：{{$momentLocal(receiveConfirmTime)}}</span>
                    </div>
                    <div class="should-pay">
                      <span class="bold">{{$t('fms_refund_register_dialog.cao_zuo_ren')}}：{{receiveConfirmUser}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div
        class="dialog-footer"
        slot="footer"
      >
        <el-button
          @click="visible = false"
          v-if="model.type !== 'watch'"
        >{{ $t('Common.com_cancel') }}</el-button>
        <el-button
          @click="onStore"
          v-if="model.type !== 'watch'"
          type="primary"
        >{{ $t('fms_refund_register_dialog.zan_cun') }}</el-button>
        <el-button
          @click="onConfirm"
          v-if="model.type !== 'watch'"
          type="primary"
        >{{ $t('Common.com_confirm') }}</el-button>
        <el-button
          @click="visible = false"
          v-if="model.type === 'watch'"
          type="primary"
        >{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
    <!-- 添加应退款 -->
    <add-refund-order
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @change="onAddRefundSuccess"
    ></add-refund-order>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import billContainer from '../../components/bill_container';
import addRefundOrder from './add_refund_order';
import accountsRegistrationMsgBill from '../../components/accounts_registration_msg_bill';
import mixins from '../../components/mixins';

export default {
  mixins: [dialogMixins, mixins],
  props: {
    // receive: 应收   pay: 应付
    type: {
      type: String,
      default: 'receive'
    },
    // 是否反转应付，应收账号显示
    isReverse: {
      type: Boolean,
      default: false
    },
    // 1：余额是当前付款的一方  2： 余额是当前收款一方的
    balanceType: {
      type: Number,
      default: 1
    }
  },
  components: {
    billContainer,
    addRefundOrder,
    accountsRegistrationMsgBill
  },
  data() {
    return {
      provide: true,
      dialogVisible: false,
      dialogModel: {},
      form: {
        refundMethod: ''
      },
      // 应收款账单列表
      orderViewList: [],
      // 结余明细/余额记录
      partnerBalance: {},
      balanceRecord: {},
      // 收款信息
      tradeBoList: [],
      // 收款信息（附加信息）
      registerMsg: {
        balance: 0,
        deposit: 0,
        billPaymentCode: '',
        billPayment: null
      },
      // 银行流水
      tradeSellerBos: [],
      // 选中行
      firstOrderItem: {},
      tradeState: ''
    };
  },
  computed: {
    // 退款后租赁余额
    finalRest() {
      const partnerBalance = this.partnerBalance;
      const ret = partnerBalance.balanceAmount || 0;
      return ret;
    },
    // 是否使用余额
    useRest() {
      const billPayment = this.registerMsg.billPayment;
      const refundMethod = `${this.form.refundMethod}`;
      if (billPayment && billPayment.isUseBalance) {
        return billPayment.isUseBalance;
      }
      return refundMethod === '22';
    },
    // 退款方式是否是用了余额
    refundMethodIsUseBalance() {
      const refundMethod = `${this.form.refundMethod}`;
      return refundMethod === '22';
    },
    // 应退金额合计
    shouldRefundSum() {
      const list = this.orderViewList.filter(item => item.isRefundBill);
      return list.reduce((pre, item) => pre + item.paymentAmount, 0);
    },
    // 实退金额合计
    actualRefundSum() {
      return this.orderViewList.reduce((pre, item) => pre + item.paymentAmount, 0);
    },
    // 应收金额合计
    shouldReceiveSum() {
      const list = this.orderViewList.filter(item => !item.isRefundBill);
      return list.reduce((pre, item) => pre + item.paymentAmount, 0);
    },
    payableTotal() {
      return this.actualRefundSum || 0;
    },
    // 支付金额总和
    total() {
      const key = 'totalAmount';
      const list = this.tradeBoList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    balance() {
      return this.registerMsg.balance;
    },
    // 预计使用余额
    expectUseRest() {
      if (this.tradeState > 6) {
        const billPayment = this.registerMsg.billPayment;

        const useRest = this.useRest;
        const { totalPaymentAmount, totalTradeAmount } = billPayment;
        if (useRest) {
          return Math.max(0, totalPaymentAmount - totalTradeAmount);
        }
      }
      const payableTotal = (this.payableTotal || 0) * -1;
      const tradeTotal = this.total || 0;
      const balance = this.useRest ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },
    // 对公转账
    publicAmount() {
      const list = this.tradeBoList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 现金支付
    cashAmount() {
      const list = this.tradeBoList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 是否为原账单的收款方
    isReceivable() {
      const firstOrderItem = this.firstOrderItem;
      if (firstOrderItem) {
        return this.isReceivableOrg(firstOrderItem.receivableOrgId);
      }
      return false;
    },
    // 收款操作时间
    receiveConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.receiveConfirmTime;
    },
    // 收款操作人
    receiveConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.receiveConfirmUser;
    },
  },
  mounted() {
    this.firstOrderItem = this.model.row;
    this.getDicMap('payment_class');
    this.getDetail();
  },
  methods: {
    initOuterList(list) {
      const ret = list.map(item => ({
        ...item,
        isRefundBill: true
      }));
      return ret;
    },
    // 获取详情
    getDetail: function () {
      // const billId = this.model.row.billId;
      const url = this.getPaymentInfoReqUrl(this.model.row);
      this.$getJSON(url).then((res) => {
        const data = res.data;
        // 付款信息（附加信息）
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = data.deposit || 0;
        this.registerMsg.billPaymentCode = this.getPaymentCode(data);
        this.registerMsg.billPayment = data.billPayment;
        // 退款方式
        if (data.billPayment && data.billPayment.refundMethod) {
          this.form.refundMethod = `${data.billPayment.refundMethod}`;
        }
        if (data.billPayment) {
          this.tradeState = data.billPayment.tradeState;
        }
        // 应退押金明细
        if (data.orderViewList && data.orderViewList.length) {
          this.orderViewList = data.orderViewList;
        } else {
          this.orderViewList = this.initOuterList([this.model.row]);
        }
        this.orderViewList = this.formatRefundBill(this.orderViewList);
        // 付款信息
        if (data.tradeBoList && data.tradeBoList.length) {
          data.tradeBoList.forEach((item, index) => {
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              this.$set(data.tradeBoList[index], 'attachs', this.formatAttachs(imgRes.data));
            });
          });
          this.tradeBoList = [...data.tradeBoList];
        }
        // 银行流水
        if (data.tradeSellerBos && data.tradeSellerBos.length) {
          this.tradeSellerBos = data.tradeSellerBos;
        }
        // 余额信息
        this.partnerBalance = data.partnerBalance || {};
        this.balanceRecord = data.balanceRecordList ? data.balanceRecordList[0] || {} : {};
      });
    },
    // 添加应退账款
    onAddRefund: function () {
      this.dialogModel.title = this.$t('fms_refund_register_dialog.tjytzk');
      this.dialogModel.filterBillIdList = this.orderViewList.map(t => t.billId);
      this.dialogModel.receivableOrgId = this.orderViewList[0].receivableOrgId;
      this.dialogModel.payableOrgId = this.orderViewList[0].payableOrgId;
      this.dialogVisible = true;
    },
    // 添加应退账款成功
    onAddRefundSuccess: function (list) {
      const arr = [...list];
      arr.forEach((item) => {
        const { receivableOrgName, payableOrgName } = item;
        item.receivableOrgName = payableOrgName;
        item.payableOrgName = receivableOrgName;
      });
      this.orderViewList = [...this.orderViewList, ...arr];
    },
    // 删除退款账单
    onDelRefund: function (row) {
      this.orderViewList = this.orderViewList.filter(t => row.billId !== t.billId);
    },
    // 暂存
    onStore() {
      if (this.actualRefundSum > 0) {
        this.$message.error(this.$t('fms_refund_register_dialog.tkjehjbndy0'));
        return;
      }
      const billIdList = this.orderViewList.map(t => t.billId);
      this.$postJSON(apis.paymentProvisionalSave, {
        billPaymentType: 2, // 账单支付类型，1-付款，2-退款，3-撤消
        billIdList: billIdList,
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        paymentCode: this.getPaymentCode(this.registerMsg),
        tradeList: this.tradeBoList,
        refundMethod: this.form.refundMethod,
        // refundTrade: this.tradeBoList
        // isSubmit: false,
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success');
      });
    },
    // 确认保存
    onConfirm: function () {
      if (this.actualRefundSum > 0) {
        this.$message({
          type: 'warning',
          message: this.$t('fms_refund_register_dialog.tkjehjbndy0')
        });
        return;
      }
      const tradeBoList = this.tradeBoList;
      // 公账列表
      const accountList = tradeBoList.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
      if (accountList.length) {
        const noBindFlow = accountList.some(item => !item.sellerTradeCode);
        if (noBindFlow) {
          this.$message.error(this.$t('fms_refund_register_dialog.qglls'));
          return;
        }
      }

      const billIdList = this.orderViewList.map(t => t.billId);
      this.$postJSON(apis.paymentRegister, { //
        billPaymentType: 2, // 账单支付类型，1-付款，2-退款，3-撤消
        billIdList: billIdList,
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        paymentCode: this.getPaymentCode(this.registerMsg),
        tradeList: this.tradeBoList,
        refundMethod: this.form.refundMethod,
        // refundTrade: this.tradeBoList
        // isSubmit: true,
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success');
      });
    },
    // 删除银行流水（银行流水信息）
    onDelBankFlow(index) {
      this.$showConfirm(this.$t('fms_refund_register_dialog.nqdyscxzdyhlsm')).then(() => {
        const curBankFlow = this.tradeSellerBos[index];
        this.$postJSON(`${apis.paymentBankFlowDelete}/${curBankFlow.sellerTradeCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success')
          });
          this.tradeBoList.forEach((item) => {
            if (item.sellerTradeCode === curBankFlow.sellerTradeCode) {
              item.sellerTradeCode = null;
            }
          });
          this.tradeSellerBos.splice(index, 1);
        });
      });
    },
    // 更新银行流水(付款信息)
    updateBankFlow(sellerTrade, isLocal) {
      // 本地
      if (isLocal && sellerTrade) {
        if (sellerTrade.type === 'delete') {
          this.tradeSellerBos = this.tradeSellerBos.filter(t => `${t.sellerTradeCode}` !== `${sellerTrade.sellerTradeCode}`);
        } else {
          this.tradeSellerBos = [...this.tradeSellerBos, sellerTrade];
        }
        return;
      }
      const billPaymentCode = this.getPaymentCode(this.registerMsg);
      this.$getJSON(`${apis.paymentBankFlowList}/${billPaymentCode}`).then((res) => {
        this.tradeSellerBos = res.data;
      });
    }
  }
};
</script>

<style lang="scss">
.refund-register-dialog {
  .paymentConfirmUser {
    margin-top: 15px;
  }
  .bold {
    font-weight: bold;
  }
  .red-font {
    color: #ff5c5b;
  }
  .expect-rest {
    margin-top: 24px;
  }
  .info-container {
    display: flex;
    .l {
      flex: 1;
      padding-right: 20px;
    }

    .r {
      width: 350px;

      .pay-info {
        .item {
          overflow: hidden;
          &:nth-child(n + 2) {
            margin-top: 4px;
          }
          .key {
            float: left;
            font-size: 12px;
            color: #4d4d4d;
            line-height: 18px;
          }
          .val {
            overflow: hidden;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 18px;
            padding-left: 16px;
            white-space: normal;
          }
        }
      }

      .pay-info {
        background: #fff;
        padding: 10px;
        border: 1px solid whitesmoke;
        border-radius: 4px;
        overflow: hidden;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 30px;
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          overflow: hidden;

          .label {
            float: left;
          }
          .value {
            overflow: hidden;
            padding-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          &:last-child {
            border-bottom: 1px solid rgba(245, 245, 245, 1);
          }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 24px;
            color: #4d4d4d;
            font-size: 14px;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            padding: 16px;
            margin-top: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            line-height: 24px;
            font-size: 14px;
            font-weight: bold;
            margin-top: 20px;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
